import React from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const RiskMembersTable = () => {
  const {
    data = [],
    colHeaders = [],
    columns,
    rawDataLink,
    colHeaderTooltips = []
  } = useSelector((state) => state.riskMembers.table);

  const columnHeaderSlot = colHeaderTooltips.reduce((acc, column) => {
    acc[column.columnHeader] = (
      <div
        className="d-inline"
        data-tooltip-id="risk-members-table"
        data-tooltip-content={column?.tooltip}
      >
        {column?.label}
      </div>
    );
    return acc;
  }, {});

  return (
    <>
      <TableWithCustomSearch
        fileName="risk-members-logs"
        data={data}
        colHeaders={colHeaders}
        columns={columns}
        rawDataLink={rawDataLink}
        columnHeaderSlot={columnHeaderSlot}
      />
      <Tooltip id="risk-members-table" float />
    </>
  );
};

export default RiskMembersTable;
